import React, { Dispatch, SetStateAction, useRef, useState } from "react";

export function useRefState<T>(initialValue: T): [React.MutableRefObject<T>, Dispatch<SetStateAction<T>>] {
    const [state, setState] = useState<T>(initialValue);
    const stateRef = useRef<T>(state);
    stateRef.current = state;

    return [stateRef, setState];
}
